import { widgets } from "@/services/globalComponents";
const WidgetTypes = widgets;
export default WidgetTypes;
